import classNames from 'classnames';
import React from 'react';

export default function Checkbox(props) {
  return (
    <input
      type="checkbox"
      {...props}
      className={classNames(
        'border-gray-300 text-orange-600 focus:ring-orange-500 peer h-4 w-4 shrink-0 rounded-sm border border-input shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-orange-500 data-[state=checked]:text-white',
        props.className,
      )}
    />
  );
}
